import { PossibleSectionInDependencies } from './types';

export const BASE_SECTION_EXPANSION = {
  details: false,
  dependencies: false,
  usedBy: false,
  configurations: true,
  latestDeployed: false,
  tags: false,
  openAi: true,
  sourceCode: true,
};

export const PossibleSectionTitleToSectionType: { [key: string]: PossibleSectionInDependencies } = {
  Details: 'details',
  Dependencies: 'dependencies',
  'Used by': 'usedBy',
  Configurations: 'configurations',
  'Configurations Owned': 'configurations',
  Collaborations: 'configurations',
  'Latest Deployed': 'latestDeployed',
  Tags: 'tags',
  'Open AI': 'openAi',
  'Source Code': 'sourceCode',
};
